import { alertClasses } from '@mui/material';
import { SnackbarMessage } from 'notistack';
import React from 'react';
import { Alert } from '../Alert';

export type AlertSeverity = 'error' | 'info' | 'success' | 'warning';

export interface SnackbarContentProps {
  message: SnackbarMessage;
  severity: AlertSeverity;
  action?: React.ReactNode;
}

export const SnackbarContent = React.forwardRef<HTMLDivElement, SnackbarContentProps>(function SnackbarContent(
  { message, severity, action, ...otherProps },
  ref
) {
  return (
    <Alert
      ref={ref}
      {...otherProps}
      severity={severity}
      sx={{
        minWidth: 300,
        [`&.${alertClasses.root}`]: {
          alignItems: 'center',
          gap: 1, // Add spacing between message and action
        },
      }}
      aria-describedby="snackbar-content"
      Action={action}
    >
      <div id="snackbar-content">{message}</div>
    </Alert>
  );
});
